import { Button, ButtonProps, Tooltip, styled } from '@mui/material';
import classNames from 'classnames';
import { AiBackground } from 'src/components/ai/AiBackground';
import Iconify from 'src/components/iconify';
import { useLocales } from 'src/locales';

const ButtonBackground = styled(AiBackground)(({ theme }) => ({
  position: 'absolute',
  zIndex: 0,
  borderRadius: theme.spacing(1),
  overflow: 'hidden',
  width: 36,
  height: 36,
  [theme.breakpoints.up('md')]: {
    width: 40,
    height: 40,
  },
}));

const StyledButton = styled(Button)(({ theme }) => ({
  minWidth: 'unset',
  overflow: 'hidden',
  padding: 0,
  width: 36,
  height: 36,
  [theme.breakpoints.up('md')]: {
    width: 40,
    height: 40,
    color: theme.palette.common.white,
  },
  '&.isFromNav': {
    width: '100%',
    height: theme.spacing(4),
    marginBottom: theme.spacing(-0.9),
    color: theme.palette.text.primary,
    '& .MuiButton-root': {
      width: '100%',
      height: theme.spacing(4),
      minWidth: 'unset',
      '&:hover': {
        boxShadow: 'none',
      },
    },
  },
}));

export const CoperaAiButton = ({
  onClick,
  isFromNav,
}: ButtonProps & { isFromNav?: boolean }) => {
  const { translate } = useLocales();
  return (
    <Tooltip
      placement="top"
      arrow
      title={translate('communicate.rtc_controls.click_to_ask_to_copera')}
    >
      <span style={{ width: '100%' }}>
        <StyledButton
          variant={isFromNav ? 'soft' : 'text'}
          onClick={onClick}
          color={isFromNav ? 'inherit' : 'primary'}
          className={classNames({ isFromNav })}
        >
          <Iconify
            icon="copera:logo"
            sx={{
              zIndex: 1,
              mask: {
                fill: 'white',
              },
            }}
          />

          {!isFromNav && <ButtonBackground />}
        </StyledButton>
      </span>
    </Tooltip>
  );
};
